import { Merchant, merchantsApi } from '@api/services/merchants';

const assignMerchant = async (
  merchantId: string,
  userId: string,
): Promise<Merchant> => {
  const { data } = await merchantsApi.assignMerchant(merchantId, {
    user_id: userId,
  });

  if ('result' in data && data.result) return data.result;

  throw new Error('Empty response result');
};

export default assignMerchant;
